import React, {Suspense, useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import Button from 'js/components/shared/Button'

import styles from './SearchModuleSpecialRates.module.scss'
import {connect} from 'react-redux';
import {filters} from '../../drupalSettings';
import syncFilters from 'js/components/shared/actions/syncFilters'
import filterChange from '../../actions/filterChange';
import filterApply from '../../actions/filterApply';
import ModuleSpecialRatesForm from './components/ModuleSpecialRatesForm';
import {FILTER_CODE} from '../../constants';
import {pushFiltersApply, pushFiltersClose} from 'js/helpers/gtm';

const cx = classnames.bind(styles);

const SearchModuleSpecialRates = function ({
   data = [],
   className,
   activeFilter,
   filterChangeAction,
}) {
  const isActive = useMemo(() => activeFilter === FILTER_CODE, [activeFilter])

  const onPreviewClick = function (e) {
    e.preventDefault();
    filterChangeAction('activeFilter', FILTER_CODE)
  }

  const onFormClose = function () {
    filterChangeAction('activeFilter', null)
    pushFiltersClose('code')
  }

  const onCodeFormSubmit = function () {
    pushFiltersApply('code')
  }

  return (
    <div className={cx('root', className)}>
      <Button
        theme="link"
        onClick={onPreviewClick}
        className={cx('link')}
      >{filters.code.label}</Button>
      {isActive && (
        <Suspense>
          <ModuleSpecialRatesForm
            data={data}
            onSubmit={onCodeFormSubmit}
            onClose={onFormClose}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleSpecialRates.propTypes = {
  data: PropTypes.any
}

export default connect(({form}) => ({
  data: form?.searchFilters?.code || [],
  activeFilter: form?.searchFilters?.activeFilter,
}), {
  filterChangeAction: filterChange,
  filterApplyAction: filterApply,
  syncFiltersAction: syncFilters,
})(SearchModuleSpecialRates);
